import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// 定义各语言的配置
const messages = {
  zn: {
    topdoor: {
      importTime: '导入时间',
      importDoor: '导入门店信息',
      deleteDoor: '确认删除该门店吗',
      deleteStoreInspection: '确认删除该巡店信息吗',
      confirmDelete: '确认删除吗',
    },
    storeInspection: {
      inspection: '巡店',
      storeId: '巡店ID',
      enterId: '请输入巡店ID',
      storeType: '机会点类型',
      chooseType: '请选择机会点类型',
      chanceDesc: '机会点描述',
      search: '模糊搜索',
      inspectionDate: '巡店时间',
      importDoor: '导入巡店记录',
      addStore: '新增巡店信息',
      update: '更新状态',
      matchUpdate: '批量状态更新',
      export: '导出数据',
      exportImage: '导出图片',
      storeInfo: '门店信息',
      storeDetail: '巡店详情',
      bookExport: '预约时间',
      immediate: '立刻导出',
      exportStoreImage: '导出巡店图片',
      exportType: '导出方式',
      exportName: '导出者',
      exportCondition: '导出条件',
      dataType: '数据类型',
      createSuccess: '创建完成',
      createTip: '创建完成后,巡店状态更改为待处理',
      surrounding: '环境'
    },
    filters: {
      date: '日期',
      chooseDate: '请选择日期',
      region: '区域',
      chooseRegion: '请选择区域',
      locate: '地区',
      chooseLocate: '请选择地区',
      province: '省份',
      chooseProvince: '请选择省份',
      city: '城市',
      chooseCity: '请选择城市',
      reseller: '客户',
      chooseReseller: '请选择客户',
      subReseller: '二级客户',
      chooseSubReseller: '请选择二级客户',
      gender: '性别',
      chooseGender: '请选择性别',
      age: '年龄',
      chooseAge: '请选择年龄',
      buyWill: '购买意愿',
      chooseBuyWill: '请选择购买意愿',
      doorName: '门店名',
      doorNo: '门店号',
      chooseDoorName: '请输入门店名',
      choosePOSID: '请输入门店编号',
      time: '时间',
      chooseMonth: '选择月',
      dangqian: '当前',
      tongbi: '同比',
      huanbi: '环比',
      column: '栏目',
      chooseColumn: '请选择栏目',
      chooseDoor: '选择门店',
      pick: '选择',
      search: '搜索',
      category: '分类',
      chooseCategory: '请选择分类',
      indicator: '指标',
      chooseIndicator: '请选择指标',
      type: '类型',
      chooseType: '请选择类型',
      questionName: '题目名称',
      enterQuestionName: '请输入题目名称',
      tryOn: '试穿情况',
      chooseTryOn: '请选择试穿',
      storeType: '门店类型',
      chooseStoreType: '请选择门店类型',
      publicAccountType: '公众号类型',
      choosePublicAccountType: '请选择公众号类型',
      publicAccountName: '公众号名称',
      enterPublicAccountName: '请输入公众号名称',
      bindStatus: '绑定状态',
      chooseBindStatus: '请选择绑定状态',
      enterStorePhase: '请输入Store Phase',
      enterDoorAddress: '请输入门店地址'
    },
    index: {
      oneKeyExport: '一键导出',
      firstLevel: '一级/总体报告',
      firstLevelSub: '全国',
      secondLevel: '二级/城市排名报告',
      thirdLevel: '三级/门店排名报告',
      fourthLevel: '四级/单店报告',
      explain: '报告说明',
      overallSatisfaction: '整体满意度',
      osat1: '顾客对于本次商店体验的满意程度。OSAT=选择“非常满意”的顾客数/总顾客数*100%。其中，顾客对店铺氛围、运动员表现、试穿服务，与收银服务的满意度计算方式与此相同。',
      netweapValue: '净推荐值',
      nps1: '顾客向亲友推荐NIKE的可能性。NPS=（高忠诚度顾客总数-低忠诚度顾客总数）/总顾客数*100%，其中，高忠诚度顾客=选择9-10分的推荐者；中忠诚度顾客=选择7-8分的中立者；低忠诚度顾客=选择0-6分的批评者。',
      tryOn1: '试穿率=已试穿顾客数/总顾客数*100%；鞋试穿率=“我试穿了鞋”被选择的总次数/已试穿顾客数*100%（服装和装备的试穿率计算方式与此相同）。同时，用户也可以查询不同试穿人群的数据。',
      whatRealTime: '什么是“当天实时”',
      whatRealTimeDesc: '门店当天有不满意顾客留言时，HC/AHC会看到“当天实时”处有红点提醒，点击可一键查看当天实时问卷数和不满意顾客留言。其中，不满意顾客留言即低忠诚度顾客留言。',
      unValid: '什么是无效问卷',
      unValid1: '1. 问卷填写时长过短将不计入分析，计算公式为：提交问卷（EndTime） - 进入答题页面（StartTime） ＜ 答题数 * 2秒',
      unValid2: '2. 样本数过低将不计入分析，即当一家店铺在月度/季度/年度的总问卷数小于30时，查询该月/季/年的报告时为空。',
      unValid3: '3. 10:00-22:00营业时间之外的问卷，将不计入分析。',
      unValid4: '备注：无效数据将保留在原始数据中，可前往PC端“报表管理”下载查看。除原始数据之外的所有数据，均为有效数据结果。用户也可在APP “四级/单店报告 - 机会点” & PC端 “报表管理 - 门店问卷统计” 中查看店铺问卷的完成情况。',
      conditions: '筛选影响条件',
      search: '点击检索',
      sampleOverview: '样本概况',
      sampleCount: '样本数',
      doorCount: '门店数量',
      cityCount: '城市数量',
      noPurchaseRate: '未购买率',
      satisfaction: '满意度',
      storeAtmosphere: '店铺氛围',
      athleticPerformance: '运动员表现',
      tryOn: '试穿服务',
      cashierService: '收银服务',
      highLoyalty: '高忠诚度',
      middleLoyalty: '中忠诚度',
      lowLoyalty2: '低忠诚度',
      midLoyalty: '中立者',
      lowLoyalty: '批评者',
      highScore: '推荐者(9-10分)',
      midScore: '中立者(7-8分)',
      lowScore: '批评者(0-6分)',
      customerVoice: '顾客声音',
      customerInfo: '顾客信息',
      inAll: '在所有',
      inHigh: '高忠诚度的顾客（Promoters）里',
      inLow: '低忠诚度的顾客（Detractors）里',
      sayMost: '他们提出最多的为：',
      buyReason: '影响购买因素',
      buyFor: '购买产品的目的',
      notBuyReason: '未购买产品的原因',
      trendChart: '趋势图',
      nationwide: '全国',
      time: '时间',
      surveyCount: '问卷数',
      preMonth: '比上月',
      notBuyRate: '未购买占比',
      rank: '排行榜',
      sort: '排序',
      nationalRank: '全国排名',
      nationalCityCount: '全国城市数量',
      nationalDoorCount: '全国门店数量',
      cityPerformance: '城市表现',
      doorPerformance: '门店表现',
      satisfied1: '非常满意',
      satisfied2: '比较满意',
      satisfied3: '满意',
      satisfied4: '比较不满意',
      satisfied5: '非常不满意',
      sample: '样本',
      all: '全部',
      buyWill1: '想要好买,买了',
      buyWill2: '想要好买,没买',
      buyWill3: '没想买,买了',
      buyWill4: '没想买,没买',
      keyMetrics: '关键指标',
      try: '试穿体验',
      overallPerformance: '整体表现',
      tryRate: '试穿率',
      specifics: '具体情况',
      serviceFeel: '服务感受',
      score: '分数',
      distribution: '满意度分布',
      specificPerformance: '具体表现',
      opportunityPoints: '机会点',
      needImprove: '我们需要改进的方面',
      highCustomer: '高忠诚度的顾客',
      lowCustomer: '低忠诚度的顾客',
      name: '姓名',
      needLearn: '你需要学习的课程',
      customTopics: '定制题目',
      tryCloth: '试穿服装',
      tryShoe: '试穿鞋子',
      tryEquipment: '试穿装备'
    },
    store: {
      title: '门店管理',
      downloadTemplate: '下载模板',
      matchSearch: '门店匹配查询',
      doorName1: '店名',
      downloadPost: '海报下载',
      uploadPreview: '上传预览',
      doorName2: '门店名称',
      pubMatch: '公共服务匹配状态',
      UMatch: 'ListenU匹配状态',
      exportResult: '导出结果',
      disableDoor: '确认禁用该门店吗',
      doorAddress: '门店地址',
      deleteDoor: '确认删除该门店吗',
    },
    question: {
      title: '题库管理',
      name: '题目名称',
      stem: '题干',
      questionType: '题目类型',
      questionStem: '题目题干',
      questionColumn: '题目栏目',
      questionCategory: '题目分类',
      indicator: '指标',
      options: '题目选项',
      type1: '单选题',
      type2: '多选题',
      type3: '打分题',
      type4: '描述题',
      type5: '题目组',
      maxScore: '最大分值',
      chooseMaxScore: '请选择最大分值',
      isInput: '是否输入项',
      isRequired: '是否必填',
      range1: '通用',
      range2: '简英(大陆)',
      range3: '繁英(港台)',
      addOption: '添加选择项',
      deleteQuestion: '确认删除该题目吗',
      switchType: '你确定切换吗',
      switchConfirm: '切换本页面内容将被清空'
    },
    survey: {
      title: '主问卷管理',
      name: '名称',
      chooseName: '请输入问卷名称',
      status: '状态',
      surveyName: '问卷名称',
      remark: '备注',
      preview: '预览问卷',
      edit: '编辑问卷',
      statusEnable: '已启用',
      statusDisable: '未启用',
      deleteSurvey: '确认删除该问卷吗',
      pic: '图片',
      enableStatus: '启用状态',
      offReason: '下架原因',
      needName: '问卷名称不能为空',
      needRelate: '关联问卷不能为空',
      question: '问卷题目',
      depend: '依赖于',
      di: '第',
      ti: '题',
      fen: '分',
      option: '选项',
      skip: '跳转',
      questionGroupName: '题目组名称',
      addQuestion: '添加题目',
      addGroup: '添加题目组',
      editLogic: '编辑题目逻辑',
      chooseSkip: '请选择要跳转到的题目',
      curScore: '当前分值',
      addScore: '添加分段',
      questionDep: '此题目依赖于',
      appear: '中的任意一个时,该题目才出现',
      multiDep: '多题依赖逻辑',
      depType1: '且:需要同时满足所有条件',
      depType2: '或:仅需满足一个条件',
      chooseDep: '选择依赖的题目',
      deleteDep: '确认删除该依赖题目吗',
      skipType1: '按顺序跳转至下一题',
      skipType2: '跳至问卷结尾结束作答',
      skipType3: '视为无效问卷',
      surveyEnd: '问卷结尾',
      invalid: '无效问卷',
      chooseQuestion: '选择题目',
      customizeTitle: '定制问卷管理',
      startTime: '开始日期',
      endTime: '结束日期',
      relate: '关联主问卷',
      valid: '有效时间',
      storeCount: '适用门店数',
      surveyValid: '问卷有效期',
      range: '适用范围',
      range1: '按条件选择',
      range2: '选择具体门店',
      systemDoorName: '系统内门店名称',
      matchStatus: '匹配状态',
      confirmUp: '确认上传'
    },
    newSurvey: {
      title: '问卷管理',
      name: '名称',
      status: '状态',
      surveyName: '问卷名称',
      createTime: '创建时间',
      updateTime: '更新时间',
      publishTime: '发布时间',
      stopTime: '下架时间',
      autoPublishTime: '自动发布时间',
      autoStopTime: '自动下架时间',
      publish: '发布问卷',
      view: '查看问卷',
      stopPublish: '停止发布',
      onShelf: '上架',
      unShelf:'下架',
      downloadCode: '总部二维码下载',
      downloadDoorCode: '门店二维码下载',
      copy: '复制问卷',
      doorList: '门店列表',
      exportDoor: '导出门店列表',
      forbidden: '禁用',
      active: '启用',
      exportData: '导出数据',
      description: '问卷描述',
      matchDoor: '适用门店',
      accessRole: '可访问角色',
      setAccessRole: '可访问角色设置',
      question: '题目',
      other: '其他'
    },
    report: {
      title: '报表统计',
      exportCSV: '导出csv文件',
      current: '当前',
      exportTitle: '数据导出',
      index: '序号',
      type: '数据类型',
      exportTime: '导出时间',
      exportPerson: '导出者',
      exportCondition: '导出条件',
      status: '状态',
      count: '下载数',
      generate: '生成数据',
      dataType1: '原始数据',
      dataType2: '汇总数据',
      exportNow: '立刻导出',
      bookTime: '预约时间',
      chooseTime: '选择日期',
      deleteTask: '确认删除该任务吗',
      unknown: '未知',
      status1: '预约中',
      status2: '待处理',
      status3: '处理中',
      status4: '已完成',
      doorTitle: '门店问卷统计',
      surveyCount: '当月问卷完成数量',
      month: '月份',
    },
    user: {
      title: '用户管理',
      name: '姓名',
      chooseName: '请输入姓名',
      cellphone: '手机号',
      choosePhone: '请输入手机号',
      add: '新增人员',
      addPublicAdmin: '新增公众号管理员',
      addAdmin: '新增开放问卷管理员',
      edit: '编辑人员',
      role: '角色',
      deleteUser: '确认删除该用户吗',
      chooseRole: '请选择角色',
      email: '邮箱',
    },
    message: {
      customerService: '联系客服',
      telephone: '客服电话',
      workTime: '工作时间 法定工作日',
      messageBoard: '留言版',
      enterMessage: '请输入留言内容',
      messageManage: '留言管理',
      send: '发送',
      read: '已阅',
      account: '账号',
      messageContent: '留言内容',
      messageTime: '时间',
      confirmDelete: '确认删除留言吗'
    },
    setting: {
      setting: '系统配置',
      newIndicators: '新增指标',
      indicatorsManage: '指标管理',
      indicatorsType: '指标类型',
      homePageDisplay: '首页显示',
      scoreThreshold: '分值门限',
      courseNameManage: '课程名称管理',
      serviceLink: '服务环节',
      scoreCriteria: '分数标准',
      courseName: '课程名称',
      promptTextManage: '提示文字管理',
      textType: '文字类型',
      textDescription: '文字描述',
      newClassification: '新增分类',
      classificationManage: '分类管理',
      topicClassification: '题目分类',
      newColumn: '新增栏目',
      columnManage: '栏目管理',
      columnName: '栏目名称',
      tongHuan: '同比环比',
      allowableSubmissionCycle: '系统允许提交周期(天数)',
      personalInformationRequest: '请输入个人信息请求提示语',
      appBackgroundPicture: 'App背景图片',
      differenceThreshold: '差异阈值',
      enterDifferenceThreshold: '请输入差异阈值',
      displayHomePage: '是否显示在首页',
      confirmDeleteIndicator: '确认删除该指标吗',
      confirmDeleteClassification: '确认删除该分类吗',
      confirmDeleteColumn: '确认删除该栏目吗',
      doorDetail: '门店详情'
    },
    post: {
      title: '海报管理',
      listTitle: '海报列表',
      postName: '海报名',
      deletePost: '确认删除该海报吗',
      postUrl1: 'APP登录图片(简)',
      postUrl2: 'APP登录图片(繁)',
      welcomePosterUrl1: '问卷欢迎图片(简)',
      welcomePosterUrl2: '问卷欢迎图片(繁)',
      welcomePosterUrl3: '问卷欢迎图片(英)',
      finishedPosterUrl1: '问卷结束图片(简)',
      finishedPosterUrl2: '问卷结束图片(繁)',
      finishedPosterUrl3: '问卷结束图片(英)',
      qrCodeX: '二维码位置  X坐标',
      qrCodeY: '二维码位置  Y坐标',
      qrCodeSize: '二维码位置  边长',
      enterX: '请输入 X坐标',
      enterY: '请输入 Y坐标',
      enterSize: '请输入 边长',
      coordinate: '坐标'
    },
    login: {
      userName: '用户名',
      enterName: '请输入用户名',
      password: '密码',
      enterPassword: '请输入密码',
      login: '登录',
      logout: '退出登录',
      noMenu: '没有配置菜单权限'
    },
    sourceMaterial: {
      season: '季节',
      theme: '主题',
      chooseSeason: '请选择季节',
      chooseTheme: '请选择主题',
      enterSKU: '请输入SKU',
      createFile: '新建文件夹',
      downloadSourceMaterial: '下载素材',
      uploadSourceMaterial: '上传素材',
      chooseAllSourceMaterial: '全选素材',
      allSourceMaterial: '全部素材',
      patchDelete: '批量删除',
      success: '完成',
      fileName: '文件名称',
      fileType: '文件类型',
      uploadTime: '上传时间',
      enterFileName: '请输入文件名称',
      chooseFileType: '请选择文件类型',
      chooseUploadTime: '请选择上传时间',
      category: '分类',
      chooseCategory: '请选择分类'
    },
    materialCategory: {
      name: '名称',
      enterCategoryName: '请输入素材分类名称',
      sort: '排序',
      createCategory: '新增素材分类',
      editCategory: '编辑素材分类'
    },
    skuRelation: {
      enterSKU: '请输入SKU',
      enterLooks: '请输入Looks编号',
      looks: 'Looks编号',
      file: '所属文件夹',
      chooseFile: '请选择所属文件夹',
      importDate: '关系表导入时间',
      chooseImportDate: '请选择关系表导入时间',
      import: '导入关系表'
    },
    materialUseStatistics: {
      customTimeScope: '自定义时间段',
      recentPushTime: '最近推文时间',
      fansAmount: '粉丝数',
      twoWeekUse: '连续两周使用素材',
      twoWeekUnUse: '连续两周未使用素材',
      monthUseAmount: '当月累计使用次数',
      pushName: '推文名称',
      pushTime: '推文时间',
      readAmount: '阅读人数',
      reductionReadAmount: '单日去重后阅读人数',
      sendPerson: '推文送达人',
      readRate: '阅读率',
      isUse: '是否使用素材',
      brandMaterial: '品牌素材',
      OOTDMaterial: 'OOTD素材',
      paiLiXueTemplate: '拍立学模版',
      doorMaterial: '门店素材',
      remark: '备注',
      doorList: '门店列表',
      materialPic: '素材图片',
      isInLibrary: '素材是否来自素材库',
      libraryWatermark: '素材水印编码',
      manualReview: '人工审核'
    },
    calendar: {
      setMaterialType: '素材类型设置',
      editMaterialType: '编辑大类',
      createMaterialType: '新增大类',
      confirmDeleteMaterial: '确认删除素材',
      addMaterial: '添加素材',
      chooseMaterialType: '请选择素材类型',
      chooseMaterialFile: '请选择素材文件夹',
      addSuggestion: '添加建议',
      chooseMaterialOrigin: '请选择素材来源',
      enterTheme: '请输入主题名称',
      categoryName: '大类名称',
      enterCategoryName: '请输入大类名称',
      month: '月份',
      week: '周期',
      bigCategory: '大类型',
      sonCategory: '子类型',
      materialType: '素材类型',
      materialFile: '素材文件夹',
      suggestionTheme: '建议主题',
      suggestionOrigin: '素材来源',
    },
    task: {
      name: '任务名称',
      type: '任务类型',
      chooseType: '请选择任务类型',
      startRange: '开始时间范围',
      endRange: '截止时间范围',
      region: '区域',
      createTask: '创建全国任务',
      remark: '备注',
      enterRemark: '请输入备注',
      creator: '创建人',
      startTime: '开始时间',
      endTime: '截止时间',
      endTime2: '结束时间',
      timeRange: '时间范围',
      taskTimeRange: '任务时间范围',
      complete: '任务完成情况',
      exportDoor: '导出数据',
      exportImage: '导出图片',
      taskDate: '任务日期',
      range0: '指定门店',
      range1: '指定用户',
      taskSubmitter: '任务提交人',
      enterTaskSubmitter: '请输入任务提交人',
      previewPic: '任务预览图',
      seeAllPics: '查看全部图片',
      seeWorkDetail: '查看工时详情',
      seeQuestionDetail: '查看题目详情',
      enterName: '请输入任务名称',
      taskStatus: '任务状态',
      chooseTaskStatus: '请选择任务状态',
      sfl: 'SFL2.0打分',
      isSFL: '是否SFL2.0打分',
      enterDoorTask: '请输入巡店任务数',
      doorTask: '本次巡店检查项',
      doorTime: '巡店时间',
      doorPerson: '巡店人',
      enterDoorPerson: '请输入巡店人',
      seeTaskDetail: '查看任务详情',
      taskDetail1: '任务详情',
      totalScore: '总分',
      enterTotalScore: '模糊搜索总分',
      estimateTime: '评估时间',
      estimatePerson: '评估人',
      consumer: '顾客',
      team: '团队',
      individual: '个人',
      system: '系统',
      chooseSystem: '请选择系统',
      taskPeriod: '任务周期',
      notComplete: '未完成',
      notAudit: '未审核',
      completed: '已完成',
      taskNum: '任务数',
      completeRate: '完成率',
      rateStatistics: '占比统计',
      taskList: '任务列表',
      taskTitle: '任务标题',
      taskBasic: '任务基本信息',
      autoContinue: '自动续订',
      hourDate: '工时收集日期',
      hourStartDate: '工时收集开始日期',
      hourEndDate: '工时收集结束日期',
      relaDoor: '指定用户时是否关联门店',
      question: '信息收集题目',
      enterQuestion: '请输入题目',
      deleteTask: '确认删除任务',
      upTask: '确认上架该任务吗',
      downTask: '确认下架该任务吗',
      stopContinue: '终止续订',
      stopTask: '确认终止续订任务'
    },
    interaction: {
      name: '名称',
      enterName: '请输入名称',
      status: '状态',
      chooseStatus: '请选择状态',
      startTime: '开始时间',
      endTime: '结束时间',
      messageType: '通知类型',
      chooseType: '请选择通知类型',
      messageStatus: '通知状态',
      chooseMessageStatus: '请选择通知状态',
      title: '标题',
      messageContent: '通知内容',
      sendTime: '发送时间',
      sendType: '发送状态',
      readNum: '阅读人数',
      immediateSend: '立即发送',
      laterSend: '延迟发送',
      feedbackType: '反馈类型',
      feedbackTime: '反馈时间',
      feedbackContent: '反馈内容',
      chooseFeedbackType: '请选择反馈类型'
    },
    retailLog: {
      createFile: '新建文件夹',
      fileName: '文件夹名称',
      updateTime: '文件更新时间',
      subSystem: '归属子系统',
      chooseSubSystem: '请选择文件夹所归属子系统',
      enterFileName: '请输入文件夹名称',
      materialName: '资料名称',
      uploadExl: '上传excel'
    },
    information: {
      createTime: '创建时间',
      fileName: '文件名称',
      enterFileName: '请输入文件名称',
      condition: '适用范围',
    },
    home: '首页',
    choose: '请选择',
    reset: '重置',
    more: '更多',
    return: '返回',
    empty: '暂无数据',
    search: '查询',
    import: '导入',
    export: '导出',
    see: '查看',
    operation: '操作',
    disable: '禁用',
    enable: '启用',
    allData: '共有数据',
    matchText1: '条,其中匹配成功',
    matchText2: '条,匹配失败',
    strip: '条',
    close: '关闭',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    add: '添加',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    submit: '提交',
    download: '下载',
    yes: '是',
    no: '否',
    new: '新增',
    saveSuccess: '保存成功',
    reportExplain: '报告说明配置',
    chooseFile: '请选择文件',
    downloadTemp: '模板下载',
    set: '设置',
    failureList: '失败列表',
    failureReason: '失败原因',
    matchResult: '匹配结果',
    exportBookings: '预约导出列表',
    exportOriginData: '导出原始数据'
  },
  hk: {
    topdoor: {
      importTime: '导入时间',
      importDoor: '导入门店信息',
      deleteDoor: '确认删除该门店吗',
      deleteStoreInspection: '确认删除该巡店信息吗',
      confirmDelete: '确认删除吗',
    },
    storeInspection: {
      inspection: '巡店',
      storeId: '巡店ID',
      enterId: '请输入巡店ID',
      storeType: '机会点类型',
      chooseType: '请选择机会点类型',
      chanceDesc: '机会点描述',
      search: '模糊搜索',
      inspectionDate: '巡店时间',
      importDoor: '导入巡店记录',
      addStore: '新增巡店信息',
      update: '更新状态',
      matchUpdate: '批量状态更新',
      export: '导出数据',
      exportImage: '导出图片',
      storeInfo: '门店信息',
      storeDetail: '巡店详情',
      bookExport: '预约时间',
      immediate: '立刻导出',
      exportStoreImage: '导出巡店图片',
      exportType: '导出方式',
      exportName: '导出者',
      exportCondition: '导出条件',
      dataType: '数据类型',
      createSuccess: '创建完成',
      createTip: '创建完成后,巡店状态更改为待处理',
      surrounding: '环境'
    },
    filters: {
      date: '日期',
      chooseDate: '請選擇日期',
      region: '區域',
      chooseLocate: '請選擇地區',
      locate: '地區',
      chooseRegion: '請選擇區域',
      province: '省份',
      chooseProvince: '請選擇省份',
      city: '城市',
      chooseCity: '請選擇城市',
      reseller: '客戶',
      chooseReseller: '請選擇客戶',
      subReseller: '二級客户',
      chooseSubReseller: '請選擇二級客戶',
      gender: '性別',
      chooseGender: '請選擇性別',
      age: '年齡',
      chooseAge: '請選擇年齡',
      buyWill: '購買意願',
      chooseBuyWill: '請選擇購買意願',
      doorName: '門店名',
      chooseDoorName: '請輸入門店名',
      choosePOSID: '請輸入POSID',
      time: '時間',
      chooseMonth: '選擇月',
      dangqian: '當前',
      tongbi: '同比',
      huanbi: '環比',
      column: '欄目',
      chooseColumn: '請選擇欄目',
      chooseDoor: '選擇門店',
      pick: '選擇',
      search: '搜索',
      category: '分類',
      chooseCategory: '請選擇分類',
      indicator: '指標',
      chooseIndicator: '請選擇指標',
      type: '類型',
      chooseType: '請選擇類型',
      questionName: '題目名稱',
      enterQuestionName: '請輸入題目名稱',
      tryOn: '試穿情況',
      chooseTryOn: '請選擇試穿'
    },
    index: {
      oneKeyExport: '一鍵導出',
      firstLevel: '一級/總體報告',
      firstLevelSub: '全國',
      secondLevel: '二級/城市排名報告',
      thirdLevel: '三級/門店排名報告',
      fourthLevel: '四級/單店報告',
      explain: '報告說明',
      overallSatisfaction: '整體滿意度',
      osat1: '顧客對於本次商店體驗的滿意程度。 OSAT=選擇「非常滿意」的顧客數/總顧客數*100%。其中，顧客對店鋪氛圍、運動員表現、試穿服務，與收銀服務的滿意度計算管道與此相同。',
      netweapValue: '淨推薦值',
      nps1: '顧客向親友推薦NIKE的可能性。 NPS=（高忠誠度顧客總數-低忠誠度顧客總數）/總顧客數*100%，其中，高忠誠度顧客=選擇9-10分的推薦者; 中忠誠度顧客=選擇7-8分的中立者; 低忠誠度顧客=選擇0-6分的批評者。 ',
      tryOn1: '試穿率=已試穿顧客數/總顧客數*100%； 鞋試穿率=“我試穿了鞋”被選擇的總次數/已試穿顧客數*100%（服裝和裝備的試穿率計算管道與此相同）。 同時，用戶也可以査詢不同試穿人群的數據。',
      whatRealTime: '什麼是“當天實时”',
      whatRealTimeDesc: '門店當天有不滿意顧客留言時，HC/AHC會看到“當天實时”處有紅點提醒，點擊可一鍵查看當天實时問卷數和不滿意顧客留言。 其中，不滿意顧客留言即低忠誠度顧客留言。',
      unValid: '什麼是無效問卷',
      unValid1: '1. 問卷填寫時長過短將不計入分析，計算公式為：提交問卷（EndTime） - 進入答題頁面（StartTime） < 答題數 * 2秒',
      unValid2: '2. 樣本數過低將不計入分析，即當一家店鋪在月度/季度/年度的總問卷數小於30時，查詢該月/季/年的報告時為空。',
      unValid3: '3. 10：00-22：00上班時間之外的問卷，將不計入分析。',
      unValid4: '備註：無效數據將保留在原始數據中，可前往PC端“報表管理”下載查看。 除原始數據之外的所有數據，均為有效數據結果。用戶也可在APP“四級/單店報告-機會點”& PC端“報表管理-門店問卷統計”中查看店鋪問卷的完成情况。',
      conditions: '篩選影響條件',
      search: '點擊檢索',
      sampleOverview: '樣本概況',
      sampleCount: '樣本數',
      doorCount: '門店數量',
      cityCount: '城市數量',
      noPurchaseRate: '未購買率',
      satisfaction: '滿意度',
      storeAtmosphere: '店鋪氛圍',
      athleticPerformance: '運動員表現',
      tryOn: '試穿服務',
      cashierService: '收銀服務',
      highLoyalty: '高忠誠度',
      middleLoyalty: '中忠誠度',
      lowLoyalty2: '低忠誠度',
      midLoyalty: '中立者',
      lowLoyalty: '批評者',
      highScore: '推薦者（9-10分）',
      midScore: '中立者（7-8分）',
      lowScore: '批評者（0-6分）',
      customerVoice: '顧客聲音',
      customerInfo: '顧客資訊',
      inAll: '在所有',
      inHigh: '高忠誠度的顧客（Promoters）里',
      inLow: '低忠誠度的顧客（Detractors）里',
      sayMost: '他們提出最多的為：',
      buyReason: '影響購買因素',
      buyFor: '購買產品的目的',
      notBuyReason: '未購買產品的原因',
      trendChart: '趨勢圖',
      nationwide: '全國',
      time: '時間',
      surveyCount: '問卷數',
      preMonth: '比上月',
      notBuyRate: '未購買佔比',
      rank: '排行榜',
      sort: '排序',
      nationalRank: '全國排名',
      nationalCityCount: '全國城市數量',
      nationalDoorCount: '全國門店數量',
      cityPerformance: '城市表現',
      doorPerformance: '門店表現',
      satisfied1: '非常滿意',
      satisfied2: '比較滿意',
      satisfied3: '滿意',
      satisfied4: '比較不滿意',
      satisfied5: '非常不滿意',
      sample: '樣本',
      all: '全部',
      buyWill1: '想要好買，買了',
      buyWill2: '想要好買，沒買',
      buyWill3: '沒想買，買了',
      buyWill4: '沒想買，沒買',
      keyMetrics: '關鍵指標',
      try: '試穿體驗',
      overallPerformance: '整體表現',
      tryRate: '試穿率',
      specifics: '具體情況',
      serviceFeel: '服務感受',
      score: '分數',
      distribution: '滿意度分佈',
      specificPerformance: '具體表現',
      opportunityPoints: '機會點',
      needImprove: '我們需要改進的方面',
      highCustomer: '高忠誠度的顧客',
      lowCustomer: '低忠誠度的顧客',
      name: '姓名',
      needLearn: '你需要學習的課程',
      customTopics: '定製題目',
      tryCloth: '試穿服裝',
      tryShoe: '試穿鞋子',
      tryEquipment: '試穿裝備'
    },
    store: {
      title: '門店管理',
      downloadTemplate: '下載範本',
      matchSearch: '門店匹配查詢',
      doorName1: '店名',
      downloadPost: '海報下載',
      uploadPreview: '上傳預覽',
      doorName2: '門店名稱',
      pubMatch: '公共服務匹配狀態',
      UMatch: 'ListenU匹配狀態',
      exportResult: '匯出結果',
      disableDoor: '確認禁用該門店嗎'
    },
    question: {
      title: '題庫管理',
      name: '題目名稱',
      stem: '題干',
      questionType: '題目類型',
      questionStem: '題目題干',
      questionColumn: '題目欄目',
      questionCategory: '題目分類',
      indicator: '指標',
      options: '題目選項',
      type1: '單選題',
      type2: '多選題',
      type3: '打分題',
      type4: '描述題',
      type5: '題目組',
      maxScore: '最大分值',
      chooseMaxScore: '請選擇最大分值',
      isInput: '是否輸入項',
      isRequired: '是否必填',
      range1: '通用',
      range2: '簡英（大陸）',
      range3: '繁英（港臺）',
      addOption: '添加選擇項',
      deleteQuestion: '確認刪除該題目嗎',
      switchType: '你確定切換嗎',
      switchConfirm: '切換本頁面內容將被清空'
    },
    message: {
      customerService: '聯系客服',
      telephone: '客服電話',
      workTime: '工作時間法定工作日',
      messageBoard: '留言版',
      enterMessage: '請輸入留言內容',
      messageManage: '留言管理',
      send: '發送',
      read: '已閱',
      account: '帳號',
      messageContent: '留言內容',
      messageTime: '時間',
      confirmDelete: '確認删除留言嗎'
    },
    survey: {
      title: '主問卷管理',
      name: '名稱',
      chooseName: '請輸入問卷名稱',
      status: '狀態',
      surveyName: '問卷名稱',
      remark: '備註',
      preview: '預覽問卷',
      edit: '編輯問卷',
      statusEnable: '已啟用',
      statusDisable: '未啟用',
      deleteSurvey: '確認删除該問卷嗎',
      pic: '圖片',
      enableStatus: '啟用狀態',
      offReason: '下架原因',
      needName: '問卷名稱不能為空',
      needRelate: '關聯問卷不能為空',
      question: '問卷題目',
      depend: '依賴於',
      di: '第',
      ti: '題',
      fen: '分',
      option: '選項',
      skip: '跳轉',
      questionGroupName: '題目組名稱',
      addQuestion: '添加題目',
      addGroup: '添加題目組',
      editLogic: '編輯題目邏輯',
      chooseSkip: '請選擇要跳轉到的題目',
      curScore: '當前分值',
      addScore: '添加分段',
      questionDep: '此題目依賴於',
      appear: '中的任意一個時，該題目才出現',
      multiDep: '多題依賴邏輯',
      depType1: '且:需要同時滿足所有條件',
      depType2: '或:僅需滿足一個條件',
      chooseDep: '選擇依賴的題目',
      deleteDep: '確認删除該依賴題目嗎',
      skipType1: '按順序跳轉至下一題',
      skipType2: '跳至問卷結尾結束作答',
      skipType3: '視為無效問卷',
      surveyEnd: '問卷結尾',
      invalid: '無效問卷',
      chooseQuestion: '選擇題目',
      customizeTitle: '定制問卷管理',
      startTime: '開始日期',
      endTime: '結束日期',
      relate: '關聯主問卷',
      valid: '有效時間',
      storeCount: '適用門店數',
      surveyValid: '問卷有效期',
      range: '適用範圍',
      range1: '按條件選擇',
      range2: '選擇具體門店',
      systemDoorName: '系統內門店名稱',
      matchStatus: '匹配狀態',
      confirmUp: '確認上傳'
    },
    newSurvey: {
      title: '問卷管理',
      name: '名稱',
      status: '状态',
      surveyName: '问卷名称',
      createTime: '创建时间',
      updateTime: '更新时间',
      publishTime: '發佈时间',
      stopTime: '下架时间',
      autoPublishTime: '自動發佈时间',
      autoStopTime: '自動下架时间',
      publish: '發佈問卷',
      view: '查看問卷',
      stopPublish: '停止發佈',
      onShelf:'上架',
      unShelf:'下架',
      downloadCode: '總部二維碼下載',
      downloadDoorCode: '门店二維碼下載',
      copy: '复制问卷',
      doorList: '门店列表',
      exportDoor: '导出数据',
      exportImage: '导出图片',
      forbidden: '禁用',
      active: '啓用',
      exportData: '导出数据',
      description: '问卷描述',
      matchDoor: '适用门店',
      accessRole: '可访问角色',
      setAccessRole: '可访问角色设置',
      question: '题目',
      other: '其他'
    },
    report: {
      title: '報表統計',
      exportCSV: '匯出csv檔案',
      current: '當前',
      exportTitle: '數據匯出',
      index: '序號',
      type: '資料類型',
      exportTime: '匯出時間',
      exportPerson: '匯出者',
      exportCondition: '匯出條件',
      status: '狀態',
      count: '下載數',
      generate: '生成數據',
      dataType1: '原始數據',
      dataType2: '匯總數據',
      exportNow: '立刻匯出',
      bookTime: '預約時間',
      chooseTime: '選擇日期',
      deleteTask: '確認删除該任務嗎',
      unknown: '未知',
      status1: '預約中',
      status2: '待處理',
      status3: '處理中',
      status4: '已完成',
      doorTitle: '門店問卷統計',
      surveyCount: '當月問卷完成數量',
      month: '月份',
    },
    user: {
      title: '用戶管理',
      name: '姓名',
      chooseName: '請輸入姓名',
      cellphone: '手機號',
      choosePhone: '請輸入手機號',
      add: '新增人員',
      addAdmin: '新增開放問卷管理員',
      edit: '編輯人員',
      role: '角色',
      deleteUser: '確認删除該用戶嗎',
      chooseRole: '請選擇角色'
    },
    setting: {
      setting: '系統配寘',
      newIndicators: '新增名額',
      indicatorsManage: '名額管理',
      indicatorsType: '名額類型',
      homePageDisplay: '首頁顯示',
      scoreThreshold: '分值門限',
      courseNameManage: '課程名稱管理',
      serviceLink: '服務環節',
      scoreCriteria: '分數標準',
      courseName: '課程名稱',
      promptTextManage: '提示文字管理',
      textType: '文字類型',
      textDescription: '文字描述',
      newClassification: '新增分類',
      classificationManage: '分類管理',
      topicClassification: '題目分類',
      newColumn: '新增欄目',
      columnManage: '欄目管理',
      columnName: '欄目名稱',
      tongHuan: '同比環比',
      allowableSubmissionCycle: '系統允許提交週期（天數）',
      personalInformationRequest: '請輸入個人資訊請求提示語',
      appBackgroundPicture: 'App背景圖片',
      differenceThreshold: '差异閾值',
      enterDifferenceThreshold: '請輸入差异閾值',
      displayHomePage: '是否顯示在首頁',
      confirmDeleteIndicator: '確認删除該名額嗎',
      confirmDeleteClassification: '確認删除該分類嗎',
      confirmDeleteColumn: '確認删除該欄目嗎'
    },
    post: {
      title: '海報管理',
      listTitle: '海報清單',
      postName: '海報名',
      deletePost: '確認删除該海報嗎',
      postUrl1: 'APP登入圖片',
      postUrl2: 'APP登入圖片（繁）',
      welcomePosterUrl1: '問卷歡迎圖片（簡）',
      welcomePosterUrl2: '問卷歡迎圖片（繁）',
      welcomePosterUrl3: '問卷歡迎圖片（英）',
      finishedPosterUrl1: '問卷結束圖片（簡）',
      finishedPosterUrl2: '問卷結束圖片（繁）',
      finishedPosterUrl3: '問卷結束圖片（英）',
      qrCodeX: '二維碼位置 X座標',
      qrCodeY: '二維碼位置 Y座標',
      qrCodeSize: '二維碼位置 邊長',
      enterX: '請輸入 X座標',
      enterY: '請輸入 Y座標',
      enterSize: '請輸入 邊長',
      coordinate: '座標'
    },
    login: {
      userName: '用戶名',
      enterName: '請輸入用戶名',
      password: '密碼',
      enterPassword: '請輸入密碼',
      login: '登入',
      logout: '登出',
      noMenu: '沒有配寘選單許可權'
    },
    home: '首頁',
    choose: '請選擇',
    reset: '重置',
    more: '更多',
    return: '返回',
    empty: '暫無數據',
    search: '查詢',
    import: '導入',
    export: '匯出',
    see: '查看',
    operation: '操作',
    disable: '禁用',
    enable: '啟用',
    allData: '共有數據',
    matchText1: '條，其中匹配成功',
    matchText2: '條，匹配失敗',
    strip: '條',
    close: '關閉',
    tip: '提示',
    confirm: '確定',
    cancel: '取消',
    add: '添加',
    save: '保存',
    edit: '編輯',
    delete: '刪除',
    submit: '提交',
    download: '下載',
    yes: '是',
    no: '否',
    new: '新增',
    saveSuccess: '保存成功',
    logout: '退出登錄',
    reportExplain: '報告說明配寘',
    chooseFile: '請選擇文件',
    downloadTemp: '模板下载',
    exportBookings: '预约导出列表',
    set: '设置'
  },
  en: {
    topdoor: {
      importTime: '导入时间',
      importDoor: '导入门店信息',
      deleteDoor: '确认删除该门店吗',
      deleteStoreInspection: '确认删除该巡店信息吗',
      confirmDelete: '确认删除吗',
    },
    storeInspection: {
      inspection: '巡店',
      storeId: '巡店ID',
      enterId: '请输入巡店ID',
      storeType: '机会点类型',
      chooseType: '请选择机会点类型',
      chanceDesc: '机会点描述',
      search: '模糊搜索',
      inspectionDate: '巡店时间',
      importDoor: '导入巡店记录',
      addStore: '新增巡店信息',
      update: '更新状态',
      matchUpdate: '批量状态更新',
      export: '导出数据',
      exportImage: '导出图片',
      storeInfo: '门店信息',
      storeDetail: '巡店详情',
      bookExport: '预约时间',
      immediate: '立刻导出',
      exportStoreImage: '导出巡店图片',
      exportType: '导出方式',
      exportName: '导出者',
      exportCondition: '导出条件',
      dataType: '数据类型',
      createSuccess: '创建完成',
      createTip: '创建完成后,巡店状态更改为待处理',
      surrounding: '环境'
    },
    filters: {
      date: 'Date',
      chooseDate: 'Please select date',
      region: 'Region',
      chooseRegion: 'Please select region',
      province: 'Province',
      chooseProvince: 'Please select province',
      city: 'City',
      chooseCity: 'Please select city',
      reseller: 'Reseller',
      chooseReseller: 'Please select reseller',
      subReseller: 'SubReseller',
      chooseSubReseller: 'Please select subReseller',
      gender: 'Gender',
      chooseGender: 'Please select gender',
      age: 'Age',
      chooseAge: 'Please select age',
      buyWill: 'Buy Will',
      chooseBuyWill: 'Please select willingness to buy',
      doorName: 'Store name',
      chooseDoorName: 'Please enter store name',
      choosePOSID: 'Please enter POSID'
    },
    index: {
      oneKeyExport: 'One-click Export',
      firstLevel: 'Level 1/Overall Report - National',
      explain: 'Report Description',
      overallSatisfaction: 'Overall Satisfaction',
      osat1: 'Customer satisfaction with the store experience. OSAT = Number of customers who selected "Very Satisfied" / Total number of customers * 100%. Among them, the customer\'s satisfaction with the store atmosphere, athlete performance, and fitting service is calculated in the same way as that of the cashier service.',
      netweapValue: 'Netweap Value',
      nps1: 'The possibility of customers recommending NIKE to relatives and friends. NPS = (total number of high loyalty customers - total number of low loyalty customers) / total number of customers * 100%, where high loyalty customers = choose 9-10 points of referrer; Medium loyalty customer = neutral who chooses 7-8 points; Low loyalty customer = critic who chooses a score of 0-6.',
      tryOn1: 'Trial on rate = number of customers who have tried on/total number of customers * 100%; Shoe fitting rate=total number of times "I have tried on shoes" selected/number of customers who have tried on * 100% (the fitting rate of clothing and equipment is calculated in the same way). At the same time, users can also query the data of different wear groups.',
      whatRealTime: 'What is "Real time of the day"',
      whatRealTimeDesc: 'HC/AHC will see a red dot reminder at the "Real time of the day" when the store leaves a message from a dissatisfied customer that day. Click it to view the number of real-time questionnaires of the day and the messages from dissatisfied customers. Among them, dissatisfied customers leave messages, that is, low loyalty customers leave messages.',
      unValid: 'What is an invalid questionnaire',
      unValid1: '1. Too long to fill out the questionnaire will not be counted in the analysis, and the formula is: Submit a questionnaire (EndTime) - Enter the answer page (StartTime) < The number of answers * 2 seconds',
      unValid2: '2. A low sample size will not be counted in the analysis, i.e. when a store has less than 30 total questionnaires per month/quarter/year, it will be empty to query reports for that month/quarter/year.',
      unValid3: '3. Questionnaires outside of business hours from 10:00 to 22:00 will not be counted in the analysis.',
      unValid4: 'Note: Invalid data will remain in the original data, you can go to the PC "Report Management" to download and view. All data except the original data is a valid data result.Users can also view the completion of the store questionnaire in the APP "Level 4/Single Store Report - Opportunity Point"&PC "Report Management - Store Questionnaire Statistics".',
      conditions: 'Filter Impact Criteria',
      search: 'Click Search',
      sampleOverview: 'Sample Overview',
      sampleCount: 'Number of samples',
      doorCount: 'Number of stores',
      cityCount: 'Number of cities',
      noPurchaseRate: 'Unprepared rate',
      satisfaction: 'Satisfaction',
      storeAtmosphere: 'Shop atmosphere',
      athleticPerformance: 'Athlete performance',
      tryOn: 'Try-on service',
      cashierService: 'Cash register service',
      highLoyalty: 'High loyalty',
      midLoyalty: 'Neutral',
      lowLoyalty: 'Critics',
      highScore: 'Recommenders (9-10 points)',
      midScore: 'Neutral (7-8 points)',
      lowScore: 'Critics (0-6 points)',
      customerVoice: 'Customer Voice'
    },
    home: 'Index',
    choose: 'Please select',
    exportBookings: '预约导出列表',
    reset: 'Reset'
  }
}

// 通过选项创建 VueI18n 实例
const i18n = new VueI18n({
  locale: 'zn', // 设置默认地区
  messages // 设置配置信息
})

export default i18n



// WEBPACK FOOTER //
// ./src/topdoor/lang/index.js